import type { CompanionTextureCollection, CompanionTexture } from "@workadventure/messages";

export interface CompanionTextureByIdList {
    [key: string]: CompanionTexture;
}

export interface CompanionTextureDescriptionInterface {
    id: string;
    url: string;
    // [Trajetoria] mostrado no menu de escolha
    name?: string;
}

export class CompanionTextures {
    private companionResources: CompanionTextureByIdList = {};
    private companionCollections = new Map<string, CompanionTexture[]>();

    public loadCompanionTexturesMetadata(metadata: CompanionTextureCollection[]): void {
        this.mapTexturesMetadataIntoResources(metadata);
    }

    public getCollectionsKeys(): string[] {
        return Array.from(this.companionCollections.keys());
    }

    public getCompanionCollectionTextures(key: string): CompanionTexture[] {
        return this.companionCollections.get(key) ?? [];
    }

    public mapTexturesMetadataIntoResources(collections: CompanionTextureCollection[]): void {
        const resources: CompanionTextureByIdList = {};
        for (const collection of collections) {
            const textures: CompanionTexture[] = [];
            for (const texture of collection.textures) {
                textures.push(texture);
                resources[texture.id] = texture;
                this.companionCollections.set(collection.name, textures);
            }
        }
        this.companionResources = resources;
    }
    public getCompanionResourceById(id: string): CompanionTexture {
        return this.companionResources[id];
    }

    public getCompanionCollectionAndIndexByCompanionId(id: string): [string, number] | undefined {
        for (const [key, value] of this.companionCollections.entries()) {
            // [Trajetoria] o original devolvia sempre o 1o da lista, ignorando o id
            const index = value.findIndex((texture) => texture.id === id);
            if (index !== -1) {
                return [key, index];
            }
        }
        return undefined;
    }

    public getCompanionResources(): CompanionTextureByIdList {
        return this.companionResources;
    }
}
